<script lang="ts">import { page } from "$app/stores";
import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, setContrastTextColor, stateShowSidebarMobile, toObservable, toSiteUrlWithActive } from "@infinitro/global";
import { UpdownGame } from "@infinitro/icons";
import { combineLatest, map, startWith } from "rxjs";
import { menuAutoCollapsed } from "../state";
let badgeEl;
const info$ = combineLatest([toObservable(page), toObservable(loggedIn)]).pipe(map(([_page, _loggedIn]) => {
	const [href, isActive] = toSiteUrlWithActive("/updown/updown/", _page.url.pathname, _loggedIn);
	return {
		href,
		isActive
	};
}), startWith({
	href: "",
	isActive: false
}));
const isMenuCollapsed$ = menuAutoCollapsed;
$: if (badgeEl) {
	setContrastTextColor(badgeEl, $stateUi.layout.isContrastTextColor);
}
$: useExpandedRankPresentation = $stateUi.layout?.useExpandedRankPresentation ?? false;
</script>

<div class={`custom-dropdown`}>
	<a href={$info$.href} on:click={() => stateShowSidebarMobile.set(false)}>
		<div class:dropdown-toggle--extended-rank={useExpandedRankPresentation} class={`dropdown-toggle`}>
			<div class="d-flex" class:active-not-primary={$info$.isActive}>
				<div class="dropdown-toggle-text" class:active={$info$.isActive}>
					<UpdownGame />
				</div>
				{#if !$isMenuCollapsed$}
					<span class="dropdown-toggle-text" class:active={$info$.isActive}
						>{$t(Verbiage.fomo_sidebar_updown_game)}</span
					>
					<span class="badge" bind:this={badgeEl} class:badge--extended-rank={useExpandedRankPresentation}>
						{$t(Verbiage.fomo_sidebar_exclusive)}
					</span>
				{/if}
			</div>
		</div>
	</a>
</div>

<style>
	.badge {
		border-radius: 0.75rem;
		background-color: var(--color-primary-500);
		padding-left: 0.25rem;
		padding-right: 0.25rem;
		padding-top: 1px;
		padding-bottom: 1px;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
		font-size: 0.75rem;
		line-height: 1rem;
}
	@media (min-width: 1024px) {
		.badge {
				font-size: 10px;
		}
}

	.badge--extended-rank {
		color: var(--color-text-100);
}

	.custom-dropdown {
		position: relative;
		width: 100%;
		font-size: 14px;
		font-weight: 400;
}

	.dropdown-toggle {
		position: relative;
		z-index: 40;
		display: block;
		height: 40px;
		width: 100%;
		cursor: pointer;
		border-radius: 14px;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		padding: 0.625rem;
		font-size: 14px;
		color: var(--color-text-100);
		background: var(--gradient-alternative-4);
		font-family: var(--font-main);
		display: flex;
		align-items: center;
		justify-content: space-between;
}

	.dropdown-toggle--extended-rank {
		border-color: var(--color-accent-700);
		background-color: var(--color-background-500);
		border-radius: 12px;
		background-image: unset;
}

	.dropdown-toggle-text {
		font-size: 14px;
}

	.dropdown-toggle-text.active {
		color: var(--color-primary-500);
}

	div.active-not-primary {
		opacity: 1;
}

	div.inactive-not-primary {
		opacity: 0.8;
}

	div.active-not-primary .dropdown-toggle-text {
		font-weight: 600 !important;
	}

	div.inactive-not-primary .dropdown-toggle-text {
		font-weight: 600 !important;
	}

	.d-flex {
		display: flex;
		align-items: center;
		gap: 0.5rem;
}
</style>
